var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.dialogVisibility,
        width: "60%",
        title: "Devices found",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisibility = $event
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "modal-body" },
        [
          _vm.activeDevices.length
            ? _c(
                "el-card",
                [
                  _c("h3", { staticClass: "title" }, [
                    _vm._v("\n        Active Devices\n      "),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-table",
                    {
                      ref: "activeDevicesTable",
                      attrs: { data: _vm.activeDevices },
                    },
                    [
                      _c("el-table-column", {
                        attrs: { prop: "doorbot_id", label: "Device Id" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "router-link",
                                    {
                                      attrs: {
                                        to: {
                                          name: "Device",
                                          params: {
                                            customer_id: scope.row.owner_id,
                                            doorbot_id: scope.row.doorbot_id,
                                          },
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(scope.row.doorbot_id) +
                                          "\n            "
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          41168672
                        ),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "owner_id", label: "Owner" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "router-link",
                                    {
                                      attrs: {
                                        to: {
                                          name: "Dashboard",
                                          params: {
                                            customer_id: scope.row.owner_id,
                                          },
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(scope.row.owner_id) +
                                          "\n            "
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          339428068
                        ),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "type", label: "Kind" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _vm.product(scope.row).description ||
                                          scope.row.type
                                      ) +
                                      "\n          "
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3760104296
                        ),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "name", label: "Description" },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "created_at", label: "Created at" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _vm._f("moment")(
                                          scope.row.created_at,
                                          "MM/DD/YYYY HH:mm"
                                        )
                                      ) +
                                      "\n          "
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2159184264
                        ),
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.deletedDevices.length
            ? _c(
                "el-card",
                [
                  _c("h3", [_vm._v("Inactive Devices")]),
                  _vm._v(" "),
                  _c(
                    "el-table",
                    {
                      ref: "deletedDevices",
                      attrs: { data: _vm.deletedDevices },
                    },
                    [
                      _c("el-table-column", {
                        attrs: { prop: "doorbot_id", label: "Device Id" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "router-link",
                                    {
                                      attrs: {
                                        to: {
                                          name: "Device",
                                          params: {
                                            customer_id: scope.row.owner_id,
                                            doorbot_id: scope.row.doorbot_id,
                                          },
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(scope.row.doorbot_id) +
                                          "\n            "
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2026578656
                        ),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "owner_id", label: "Owner" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "router-link",
                                    {
                                      attrs: {
                                        to: {
                                          name: "Dashboard",
                                          params: {
                                            customer_id: scope.row.owner_id,
                                          },
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(scope.row.owner_id) +
                                          "\n            "
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          339428068
                        ),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "type", label: "Kind" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _vm.product(scope.row).description ||
                                          scope.row.type
                                      ) +
                                      "\n          "
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3760104296
                        ),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "name", label: "Description" },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "created_at", label: "Created at" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _vm._f("moment")(
                                          scope.row.created_at,
                                          "MM/DD/YYYY HH:mm"
                                        )
                                      ) +
                                      "\n          "
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2159184264
                        ),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "deleted_at", label: "State" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-tooltip",
                                    {
                                      attrs: {
                                        content: _vm._f("moment")(
                                          scope.row.deleted_at ||
                                            scope.row.deactivated_at,
                                          "MM/DD/YYYY HH:mm"
                                        ),
                                      },
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.deviceState(scope.row))
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2324365594
                        ),
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.activeDevices.length
            ? _c(
                "el-card",
                [
                  _c(
                    "el-alert",
                    {
                      staticStyle: { "font-size": "20px" },
                      attrs: { closable: false, type: "warning" },
                    },
                    [
                      _vm._v("\n        Click "),
                      _c("a", { on: { click: _vm.openMissingDevice } }, [
                        _vm._v("Here"),
                      ]),
                      _vm._v(" only if there are no active devices.\n      "),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }